<template>
  <Customers />
</template>

<script>
// @ is an alias to /src
import Customers from "@/sections/lookupengine/components/Customers.vue";

export default {
  name: "customers",
  components: {
    Customers,
  },
};
</script>
